import { render } from "./news_metadata.vue?vue&type=template&id=f87dead4"
import script from "./news_metadata.vue?vue&type=script&lang=js"
export * from "./news_metadata.vue?vue&type=script&lang=js"

import "./news_metadata.vue?vue&type=style&index=0&id=f87dead4&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__